import React from "react";
import FooterPanel from "../../layout/FooterPanel";
import { Link } from "@fluentui/react";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { DocumentSources } from "../../cpm/DocumentSources";
import { SourcesListPanelLoader } from "../../cpm/SourcesListPanelLoader/SourcesListPanelLoader";
import { useDocumentSourcePanel } from "./DocumentSourcePanelHook";
import HeaderPanel from "../../layout/HeaderPanel";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { ButtonVariants } from "../../../styles/fluent/ButtonVariants";
import { DocumentPart } from "../../../api/models";

export interface DocumentSourcesPanelProps {
  idPartRoot: string;
  documentPart: DocumentPart;
}

export const DocumentSourcesPanel: React.FunctionComponent<DocumentSourcesPanelProps> = (props) => {
  const defaultHeaderName = formatMessage("cof.documentsources.viewall.subtitle");
  const { isViewList, headerName, selectedSource, onItemSingleClick, goBack, loadViewList } =
    useDocumentSourcePanel(props);

  const title = formatMessage("cof.documentsources.header");

  if (isViewList)
    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <HeaderPanel applyPadding>{title}</HeaderPanel>
        <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
          <SourcesListPanelLoader
            headerName={headerName}
            documentPartTreeSelection={selectedSource}
            documentPart={props.documentPart}
          />
        </div>
        <FooterPanel>
          <PrimaryButton className={ButtonVariants.white} text={formatMessage("cof.base.back")} onClick={goBack} />
        </FooterPanel>
      </div>
    );
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <HeaderPanel applyPadding>{title}</HeaderPanel>
      <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
        <DocumentSources onItemSingleClick={onItemSingleClick} idPartRoot={props.idPartRoot} />
      </div>
      <FooterPanel>
        <Link
          style={{ textDecoration: "none" }}
          onClick={() => loadViewList(defaultHeaderName)}
          className={ButtonVariants.link}
        >
          {formatMessage("cof.documentsources.viewall")}
        </Link>
      </FooterPanel>
    </div>
  );
};
